import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import { RootState } from 'store/store';
import { IRequestsListState } from './interfaces';
import { getRequest } from 'api/requests';

// Загрузка списка логов
export const fetchRequests = createAsyncThunk(
  'requestsList/fetchRequests',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getRequest('request', {}, true);

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// Selectors
export const RequestsListSelector = (state: RootState): IRequestsListState =>
  state.requestsList;

export const RequestsListLoadingSelector = createSelector(
  RequestsListSelector,
  ({ isLoading }) => isLoading,
);

export const RequestsListItemsSelector = createSelector(
  RequestsListSelector,
  ({ items }) => items,
);

const initialState: IRequestsListState = {
  isLoading: false,
  items: [],
};

const requestsListSlice = createSlice({
  name: 'requestsList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRequests.pending, (state) => ({
        ...state,
        isLoading: true,
      }))
      .addCase(fetchRequests.rejected, (state) => ({
        ...state,
        isLoading: false,
      }))
      .addCase(fetchRequests.fulfilled, (state, { payload }) => ({
        ...state,
        isLoading: false,
        items: payload,
      }));
  },
});

export default requestsListSlice.reducer;
